import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import "../Search/Search.css";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  AI_DECISION_MAKER,
  AI_LEADS,
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMPANY_PROFILE_SCREEN,
} from "../../../Utils/Constants";
import { toast } from "react-toastify";
import { APIUrlThree, APIUrlToken } from "../../../Utils/Utils";
import axios from "axios";
import redPeople from "../../../Assets/peopleFavRed.svg";
import redOrg from "../../../Assets/orgFavRed.svg";
import greyPeople from "../../../Assets/peopleFavGrey.svg";
import greyorg from "../../../Assets/orgFavGrey.svg";

export default function HeaderSearch({ setLoading }) {
  const navigate = useNavigate();
  const [showSearchdata, setshowSearchdata] = React.useState(false);
  const [headerSearchData, setheaderSearchData] = React.useState("");
  const [responseData, setResponseData] = React.useState(null);
  const [searchTabs, setSearchTabs] = React.useState("org");
  React.useEffect(() => {
    const handleClick = (event) => {
      if (event.target.closest(".multi_search_header")) {
        return;
      }
      setshowSearchdata(false);
      // setheaderSearchData("");
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  const handleOrganizationsearch = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      data: { org_name: headerSearchData },
      url: `${APIUrlThree()}/v1/universal_search_org?skip=0&limit=100`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(true);
          const sortedOrgData = response?.data?.data.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          setResponseData(sortedOrgData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message);
      });
  };
  const handlePeoplesearch = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      data: { people_name: headerSearchData },
      url: `${APIUrlThree()}/v1/universal_search_people?skip=0&limit=100`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(true);
          const sortedOrgData = response?.data?.data.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          setResponseData(sortedOrgData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message);
      });
  };
  React.useEffect(() => {
    let timer;
    if (headerSearchData?.length > 2) {
      timer = setTimeout(() => {
        if (searchTabs === "org") {
          handleOrganizationsearch();
        } else {
          handlePeoplesearch();
        }
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [headerSearchData]);
  React.useEffect(() => {
    if (searchTabs && headerSearchData?.length > 2) {
      if (searchTabs === "org") {
        handleOrganizationsearch();
      } else {
        handlePeoplesearch();
      }
    }
  }, [searchTabs]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setshowSearchdata(false);
      if (searchTabs === "org") {
        navigate(`/organization-results`, {
          state: headerSearchData,
          replace: true,
        });
      } else {
        navigate(`/people-results`, { state: headerSearchData, replace: true });
      }
    }
  };
  const handelselectdata = (item) => {
    setheaderSearchData(item?.name);
    if (searchTabs === "org") {
      navigate(`/companyprofilescreen/${item?.org_id}/0`, {
        state: {
          isComponyScreen: window.location.pathname.includes(
            "companyprofilescreen"
          ),
        },
      });
    } else {
      navigate(`/Profile/${item?.person_id == 0 ? "0" : item?.person_id}`);
    }
  };
  const emtySearchdata = () => {
    setheaderSearchData("");
  };
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Paper
        className="full-searchbar"
        // component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}
      >
        <SearchIcon className="searchicon-in-header" />
        <InputBase
          value={headerSearchData}
          onChange={(e) => {
            const inputValue = e.target.value;
            setheaderSearchData(inputValue);
          }}
          className="search-inner-text"
          onKeyDown={handleKeyDown}
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search..."
          inputProps={{ "aria-label": "Search google maps" }}
          autoComplete="off"
        />
        <div onClick={emtySearchdata} className="cross-icon-prospect-search">
          {headerSearchData && <CloseIcon className="showicons-search" />}{" "}
        </div>
        {showSearchdata && (
          <div
            className={
              window.location.pathname === COMPANY_PROFILE_SCREEN ||
              window.location.pathname === AI_PROFILE_FORM_TABLE ||
              window.location.pathname === AI_PROSPECT_PROFILE
                ? "NewClassNamepathname"
                : (window.location.pathname === AI_LEADS ||
                    window.location.pathname === AI_DECISION_MAKER) &&
                  isMobile
                ? "Autocompletedropdown-mobile"
                : "Autocompletedropdown"
            }
            // style={

            //     ? {
            //         width: "80%",
            //         left: "10px",
            //         top: "108px",
            //       }
            //     : {}
            // }
          >
            {responseData?.length > 0 ? (
              responseData.map((item, index) => (
                <>
                  {item?.id === null ? (
                    <div
                      className="outterAutocompletedropdown2"
                      key={`heading-${index}`}
                    >
                      <div className="useralldata-search">
                        <strong>{item?.name}</strong>
                      </div>
                      <div className="separatorline"></div>
                    </div>
                  ) : (
                    <div
                      className="outterAutocompletedropdown"
                      key={item.id || `data-${index}`}
                    >
                      <div
                        onClick={() => handelselectdata(item)}
                        className="useralldata-search"
                      >
                        {[
                          item?.name?.toLowerCase() === "jp nauseef"
                            ? "JP Nauseef"
                            : item?.name
                                ?.split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" "),
                          item?.state
                            ?.split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" "),
                          item?.country
                            ?.split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" "),
                          item?.website_url?.toLowerCase(),
                          item?.primary_organization
                            ?.split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" "),
                          item?.seniority
                            ?.split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" "),
                          // item?.linkedin,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </div>

                      <div className="separatorline"></div>
                    </div>
                  )}
                </>
              ))
            ) : (
              <div className="useralldata-search">Not Available</div>
            )}
          </div>
        )}
      </Paper>
      <div className="multi_search_header">
        <p className="multi_search_header_head">Search Filters:</p>
        <div className="multi_search_header_tabs">
          <div
            onClick={() => {
              setSearchTabs("org");
            }}
            className={
              searchTabs === "org"
                ? "multi_search_header_red"
                : "multi_search_header_grey"
            }
          >
            <img src={searchTabs === "org" ? redOrg : greyorg} alt="org" />
            Organizations
          </div>
          <div
            onClick={() => {
              setSearchTabs("people");
            }}
            className={
              searchTabs === "people"
                ? "multi_search_header_red"
                : "multi_search_header_grey"
            }
          >
            <img
              src={searchTabs === "people" ? redPeople : greyPeople}
              alt="people"
            />
            People
          </div>
        </div>
      </div>
    </>
  );
}
